const whitespace = new RegExp(/^\s*$/);

/** Returns true if the specified value is a string and has non-whitespace characters. */
export function hasText(value: unknown): value is string {
  if (typeof value !== 'string') return false;

  return !(value == null || value.match(whitespace) !== null);
}
